/**
 * Mappa un deep-link di notifica verso un URL web, replicando la logica
 * `_handleDeeplLink` dell'app Flutter (home_view.dart).
 *
 * Sorgenti del link:
 *  - app-scheme: it.auting.auting://<host>?<query>
 *      reservation            -> dettaglio viaggio
 *      reservation (con 'chat') -> dettaglio viaggio (tab messaggi sull'app; su web stessa pagina)
 *      payment/success|failed -> dettaglio viaggio
 *      email/verified         -> login (sul sito)
 *      user | vehicle | altro -> fallback home
 *  - URL http/https esterni   -> usati così come sono
 *
 * @param {string} link
 * @param {{ lang?: string }} [opts]
 * @returns {string|null} URL web verso cui navigare (null se link assente)
 */
export function notificationLinkToWebUrl(link, opts = {}) {
  if (!link) return null;
  const lang = opts.lang || 'it';
  const HOME = 'https://auting.it';

  // URL esterni: invariati
  if (/^https?:\/\//i.test(link)) return link;

  // Deep-link app: it.auting.auting://<host>?<query>
  const m = link.match(/^it\.auting\.auting:\/\/([^?]+)(?:\?(.*))?$/i);
  if (!m) return HOME;
  const host = m[1];
  const params = new URLSearchParams(m[2] || '');
  const id = params.get('id');

  // Prenotazione / pagamento -> dettaglio viaggio
  if (
    host.includes('reservation') ||
    host.includes('payment/success') ||
    host.includes('payment/failed')
  ) {
    return id ? `${HOME}/viaggi/details/${id}` : HOME;
  }

  // Verifica email -> pagina di login del sito
  if (host.includes('email/verified')) {
    const email = params.get('email');
    return `${HOME}/${lang}/login${email ? `?email=${encodeURIComponent(email)}` : ''}`;
  }

  // user / vehicle / altro: nessun equivalente web certo
  return HOME;
}
